import Header from "@/components/Header";
import Footer from "@/components/Footer";
import DocumentsSection from "@/components/DocumentsSection";
import { useSearchParams } from "react-router-dom";

const Templates = () => {
  const [searchParams] = useSearchParams();
  const searchQuery = searchParams.get('search') || '';
  const categoryQuery = searchParams.get('category') || '';

  return (
    <div className="min-h-screen bg-background flex flex-col">
      <Header />
      
      <main className="flex-grow">
        {/* Page Header */}
        <div className="border-b border-border bg-secondary/30">
          <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-6">
            <h1 className="text-2xl font-bold text-foreground">
              {categoryQuery ? categoryQuery : 'All Templates'}
            </h1>
            <p className="text-muted-foreground mt-1">
              Browse and download professional templates
            </p>
          </div>
        </div>

        <DocumentsSection searchQuery={searchQuery} />
      </main>

      <Footer />
    </div>
  );
};

export default Templates;
